var module = angular.module('octopusApp.environments');

module.directive('azureCloudServiceEndpoint', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      endpoint: '='
    },
    templateUrl: 'areas/environments/views/endpoints/azure_cloud_service_endpoint.html',
    link: function($scope, el, attr) {
      var unwatch = $scope.$watch('endpoint', function() {
        if (!$scope.endpoint) {
          return;
        }
        if(!$scope.endpoint.Slot) {
          $scope.endpoint.Slot = 'Staging';
        }
        if (!$scope.endpoint.hasOwnProperty('SwapIfPossible')) {
          $scope.endpoint.SwapIfPossible = false;
          $scope.endpoint.UseCurrentInstanceCount = true;
        }
        unwatch();
      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/endpoints/azure_cloud_service_endpoint.js
// module id = 1620022467874453
// module chunks = 1